/* eslint-disable complexity */
import { FC, Fragment } from "react"
import { Regex } from "../../../../../../constant/Regex"
import { Tabs } from "../../../../../../_webui/layout/components/Tabs"
import { SchedulesAddTableButtonGroup } from "./ButtonGroup"
import { SchedulesAddTableProps } from "./models"
import { ItemRadio } from "../../../../../../_webui/layout/components/Form/Item/Radio"
import { Translate } from "../../../../../../constant/Translate"
import { Constants } from "./constants"
import { Table } from "../../../../../../_webui/layout/components/Table"

const { DETAIL_SORT_TYPES } = Constants
const { REGEX_IS_DESKTOP } = Regex
const { TEXT_T544 } = Translate

export const SchedulesAddTable: FC<SchedulesAddTableProps> = (props) => {
  const {
    activeKey,
    addText,
    columns,
    dataSource,
    dataTableSelected,
    deleteText,
    handleAdd,
    handleDelete,
    id,
    isHiddenScrollBar,
    isHiddenVerticalBar,
    isLoading,
    isTableDetail,
    isVisibleBtn,
    items,
    onTabClick,
    rowKey,
    rowSelection,
    ...res
  } = props

  return (
    <Fragment>
      {REGEX_IS_DESKTOP ? (
        <Table
          columns={columns}
          dataSource={dataSource}
          id={id}
          isBackgroundFirstChild
          isHiddenScrollBar={isHiddenScrollBar}
          isHiddenVerticalBar={isHiddenVerticalBar}
          isLoading={isLoading}
          pagination={false}
          rowKey={rowKey}
          rowSelection={rowSelection}
          {...res}
        />
      ) : (
        <Tabs
          activeKey={activeKey}
          defaultActiveKey={"1"}
          items={items}
          onTabClick={onTabClick}
        />
      )}
      {(REGEX_IS_DESKTOP || (!REGEX_IS_DESKTOP && !dataSource.length)) && (
        <SchedulesAddTableButtonGroup
          addText={addText}
          deleteText={deleteText}
          handleAdd={handleAdd}
          handleDelete={handleDelete}
          isDisabled={!dataTableSelected.length}
          isVisibleBtn={isVisibleBtn}
        />
      )}
      {isTableDetail && (
        <ItemRadio
          label={TEXT_T544}
          name="detailSortType"
          radioItems={DETAIL_SORT_TYPES}
        />
      )}
    </Fragment>
  )
}
